import { IAPI, ILockedAPI, ApiSchema } from "@/schemas/api/apiSchema";
import { LambdaStage } from "./schemas/pluginOptions/pluginOptionsSchema";
import { useNotificationsStore } from "@/stores/notifications";
import { lambdaURLs } from "./lambdaUrls";

const SERVER: string =
  ["localhost", "127.0.0.1"].indexOf(window.location.hostname) !== -1
    ? "http://private-b2d8b-editor4.apiary-mock.com/"
    : "";
const APIARY_MOCK: string =
  ["localhost", "127.0.0.1"].indexOf(window.location.hostname) !== -1
    ? "https://private-68405b-products174.apiary-mock.com/"
    : "";

export let LAMBDA_URL: string = lambdaURLs.production;

export let api: IAPI = setDefaultApi();
export let lockedApi: ILockedAPI = setLockedApi();

function setDefaultApi(): IAPI {
  return {
    GET_AUTOSAVE: APIARY_MOCK + "get-autosave",
    AUTOSAVES: APIARY_MOCK + "autosaves",
    PRODUCTS: APIARY_MOCK + "products",
    FEEDS: APIARY_MOCK + "feeds",
    AUTOSAVE: APIARY_MOCK + "autosave",
    CONVERSATIONS: SERVER + "conversations",
    COMMENTS: SERVER + "comments",
    // SAVED_SECTIONS: SERVER + "synced-rows",
    //@ts-expect-error
    SAVE: null,
    IMAGE_EDITOR_UPLOAD: "",
    IMAGE_UPLOAD: "upload",

    FOLDERS: LAMBDA_URL + "folders/{key}",
    LOAD: LAMBDA_URL + "load/{key}/account/{id}/{uuid}",
    TEST_EMAIL: LAMBDA_URL + "testmail/{key}",

    PREMADE_TEMPLATES: "https://app.topol.io/api/premade-templates",
    PREMADE_TEMPLATE_CATEGORIES:
      "https://app.topol.io/api/premade-template-categories",
    PREMADE_TEMPLATES_KEYWORDS:
      "https://app.topol.io/api/premade-template-keywords",
  };
}

export function setApi(index: keyof IAPI, value: string): void {
  if (!ApiSchema.shape[index]) {
    console.error("Error while setting api", "Index not found", index);
    const notificationsStore = useNotificationsStore();
    notificationsStore.createNotification({
      text: "Error while setting api url for " + index,
      type: "error",
    });
    return;
  }
  const { error, data, success } = ApiSchema.shape[index].safeParse(value);
  if (!success) {
    console.error("Error while setting api", error.issues);
    const notificationsStore = useNotificationsStore();
    notificationsStore.createNotification({
      text: "Error while setting api url for " + index,
      type: "error",
    });
    return;
  }
  api[index] = data;
}

function getUrlForStage(stage: LambdaStage): string {
  return lambdaURLs[stage];
}

export function setLambdaStage(stage: LambdaStage): void {
  LAMBDA_URL = getUrlForStage(stage);
  api = setDefaultApi();
  lockedApi = setLockedApi();
}

function setLockedApi(): ILockedAPI {
  return {
    GIPHY_API_KEY: "l41YcFzYxeAUvxXG0",
    GIPHY_SEARCH: "https://api.giphy.com/v1/gifs/search",
    AUTHORIZE: LAMBDA_URL + "authorize",
    GCS_SIGNED_URL: LAMBDA_URL + "get-signed-url/",
    PREVIEW_SAVE: LAMBDA_URL + "email/get-html",
    GENERATE_CHAT: LAMBDA_URL + "email/chat-generation",
    GENERATE_IMAGE: LAMBDA_URL + "generate-image",
    GENERATE_SECTION: LAMBDA_URL + "section-generation",
    GENERATE_TEXT: LAMBDA_URL + "text-generation",
    GENERATE_PREHEADER: LAMBDA_URL + "email/preheader-generation",
    GENERATE_TRANSLATION: LAMBDA_URL + "email/translation",
  };
}
